<template>
  <div>
    <confirm-dialog ref="confirmChangeTmlnDialog"></confirm-dialog>
    <confirm-dialog ref="confirmRematchDialog"></confirm-dialog>
    <card label="Pending Licence Rematch">
      <div v-if="errorRematch" class="alert alert-danger" role="alert">
        {{ errorRematch }}
      </div>
      <p class="fw-bold">
        If you would like to clear the current pending link recommendation and rematch this business
        using the current logic and data available.
      </p>
      <div class="mt-3 mb-5">
        <button type="button" class="btn btn-lg btn-primary me-3" @click="confirmRematch">
          Rematch Business
        </button>
      </div>
    </card>
    <card label="Change the Pending Licence to an Existing TMLN">
      <div v-if="canMove" class="mt-3 mb-5">
        <p class="fw-bold">
          If you would like to force a move for {{ model.registeredCompanyName }} to an existing
          TMLN
        </p>
        <div class="ps-3 pe-3">
          <div class="form-group">
            <div v-if="errorMoveTMLN" class="alert alert-danger" role="alert">
              {{ errorMoveTMLN }}
            </div>
          </div>
          <div class="mb-3">
            <label for="destinationTMLN" class="form-label"
              >Change the pending licence action to an existing TMLN</label
            >
            <input
              id="destinationTMLN"
              v-model="destinationTMLN"
              class="form-control"
              style="max-width: 250px"
              placeholder="TMLN"
            />
          </div>
          <button
            type="button"
            class="btn btn-lg btn-primary me-3"
            :disabled="destinationTMLN ? false : true"
            @click="moveTMLN"
          >
            Change Pending Licence TMLN
          </button>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { ConfirmDialog, confirmType, Card } from '@trustmark-2005-ltd/trustmark-shared-components';

export default {
  name: 'SchemeBusinessRematch',
  components: { Card, ConfirmDialog },
  data() {
    return {
      loading: false,
      errorRematch: null,
      errorMoveTMLN: null,
      canMove: true,
      destinationTMLN: null,
    };
  },
  computed: {
    model() {
      return this.$store.state.schemeBusiness.business;
    },
  },
  methods: {
    moveTMLN() {
      this.$refs.confirmChangeTmlnDialog
        .show({
          title: 'Change Pending Licence TMLN',
          message: `Are you sure you want to change the pending licence for this business to TMLN ${this.destinationTMLN}?`,
          okButtonText: 'Confirm Change',
          confirmType: confirmType.standard,
        })
        .then((result) => {
          if (result === true) {
            this.errorMoveTMLN = null;
            const payload = {
              schemeId: this.model.schemeId,
              schemeBusinessId: this.model.schemeBusinessId,
              tmln: this.destinationTMLN,
            };
            this.$store
              .dispatch('pendingLicenceAction/moveTMLN', payload)
              .then(() => {
                this.loading = false;
                window.scrollTo(0, 0);
              })
              .catch((err) => {
                this.loading = false;
                this.errorMoveTMLN = err.message ?? err;
              });
          }
        });
    },
    confirmRematch() {
      this.$refs.confirmRematchDialog
        .show({
          title: 'Confirm Rematch',
          message: 'Are you sure you want to resubmit this business for matching again now?',
          okButtonText: 'Rematch Business',
          confirmType: confirmType.standard,
        })
        .then((result) => {
          if (result === true) {
            this.errorSplitTMLN = null;
            const payload = {
              schemeId: this.model.schemeId,
              schemeBusinessId: this.model.schemeBusinessId,
              tmln: this.model.tmln,
            };
            this.$store
              .dispatch('schemeBusiness/rematch', payload)
              .then(() => {
                this.loading = false;
              })
              .catch((err) => {
                this.loading = false;
                this.errorSplitTMLN = err.message ?? err;
              });
          }
        });
    },
  },
};
</script>
